import React from "react";
import AppFormik from "src/commun/composants/formulaire/formik/AppFormik";
import ValidationCGUFormContent from "src/pages/validationCGU/form/ValidationCGUFormContent";
import useValidationSchemaValidationCGU, { AcceptCGU } from "src/pages/validationCGU/form/useValidationSchemaValidationCGU";
import { useNavigate } from 'react-router-dom';
import { fetchUser, validateCGU } from "src/app/api/AccountApi";
import { AppRoutes } from "src/routes/AppRoutes";
import { useAppState } from "src/app/state/StateProvider";

export type ValidationCGUFormProps = {
  initialValues: AcceptCGU;
};


const ValidationCGUForm = ({initialValues}: ValidationCGUFormProps) => {
  const [, dispatch] = useAppState();
  const navigate = useNavigate();

  const validationSchema = useValidationSchemaValidationCGU();
  const submitSuccessHandler = () => {
    fetchUser().then(result => {
      dispatch({ type: "setUser", payload: result});
      navigate(AppRoutes.ACCUEIL_PATH.getPath());
    });
  };

  return (
    <AppFormik
      enableReinitialize
      initialValues={initialValues}
      submitFormAPI={() => validateCGU()}
      submitSuccessHandler={submitSuccessHandler}
      validationSchema={validationSchema}
    >
      <ValidationCGUFormContent />
    </AppFormik>
  );

};

export default ValidationCGUForm;